module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-steak@2x-fe69ab782805b32babbaa3b714fe1fdb.png";